import generated from '../content/blog/posts.generated.json';

export interface BlogImage {
  src: string;
  srcSet: string;
  width: number;
  height: number;
}

export interface BlogPost {
  slug: string;
  title: string;
  seoTitle: string | null;
  description: string;
  date: string;
  updated: string | null;
  author: string;
  tags: string[];
  cover: BlogImage | null;
  coverAlt: string | null;
  image: string | null;
  lang: string;
  draft: boolean;
  readingMinutes: number;
  html: string;
  jsonLd: object;
}

// `as unknown as`: TypeScript infers the JSON's literal shape, which is never[] when there are no posts.
export const posts = generated.posts as unknown as BlogPost[];
export const blogJsonLd = generated.blogJsonLd as object;
export const BLOG_DESCRIPTION: string = generated.blogDescription;
export const BLOG_TITLE: string = generated.blogTitle;
export const BLOG_IMAGE: string = generated.blogImage;
export const BLOG_IMAGE_ALT: string = generated.blogImageAlt;

export const getPost = (slug?: string) => posts.find((post) => post.slug === slug);

export const postsForTags = (tags: string[], limit?: number) => {
  const matched = posts.filter((post) => post.tags.some((tag) => tags.includes(tag)));
  return limit === undefined ? matched : matched.slice(0, limit);
};

export const getAdjacent = (slug: string) => {
  const index = posts.findIndex((post) => post.slug === slug);
  return {
    newer: index > 0 ? posts[index - 1] : undefined,
    older: index >= 0 ? posts[index + 1] : undefined,
  };
};

export const formatDate = (iso: string, lang = 'en') =>
  new Intl.DateTimeFormat(lang === 'es' ? 'es-PR' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(`${iso}T00:00:00Z`));

export const readingLabel = (minutes: number, lang = 'en') =>
  lang === 'es' ? `${minutes} min de lectura` : `${minutes} min read`;
